import { getQtyBreakPricingService } from "@crescentParts/Services/CustomQuantityBreakPricingService";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

export interface CustomQtyBreakPricingParameter {
    customerNumber: string;
    productNumber: string;
    onError: (error: string) => void;
}

type HandlerType = Handler<CustomQtyBreakPricingParameter>;

export const startFetching: HandlerType = props => {
    (props as unknown as any).dispatch({
        type: "CustomQuantityBreakPricing/StartFetching",
    });
};

export const getBreakPrice: HandlerType = async props => {
    try {
        const result = await getQtyBreakPricingService({
            customerNumber: props.parameter.customerNumber,
            productNumber: props.parameter.productNumber,
        });
        if (result.successful) {
            (props as unknown as any).dispatch({
                type: "CustomQuantityBreakPricing/Update",
                payload: result.result,
            });
        } else {
            props.parameter.onError(result?.errorMessage);
        }
    } catch (err) {
        props.parameter.onError(err?.errorMessage || err);
    }
};

export const completeFetching: HandlerType = props => {
    (props as unknown as any).dispatch({
        type: "CustomQuantityBreakPricing/CompleteFetching",
    });
};

export const chain = [startFetching, getBreakPrice, completeFetching];

const getQuantityBreakPricing = createHandlerChainRunner(chain, "GetQuantityBreakPricing");
export default getQuantityBreakPricing;
